import React from 'react';
import './Help.scss';
import videoIcon from '../assets/video.svg';
import pdfIcon from '../assets/pdf.svg';
import httpService from '../services/httpService';
import { ApiEndpoints } from '../constants/appConstants';

const Help: React.FC = () => {
  
  const downloadDataFile = (documentType: string) => {
        httpService
            .get(
                `${ApiEndpoints.DownloadResourceByDocumentType}/${documentType}`
            ).then((response: any) => {
                    if (response) {
                        //console.log("response", response);
                        let url = response.data.url;
                        const validatedUrl = new URL(url);
                        if (
                            validatedUrl.protocol === "http:" ||
                            validatedUrl.protocol === "https:"
                        ) {
                            const anchor = document.createElement("a");
                            anchor.href = validatedUrl.toString();
                            anchor.target = "_blank";
                            anchor.click();
                        }
                    }
                },
                (error: any) => {
                    console.error("Error downloading file:", error);
                }
            );
    };

  return (
    <section className="helpsection">
      <div className="helpheader">
        <strong>Help Documentation</strong>
      </div>
      <div style={{ paddingLeft: '2%' }}>
        <strong className="help">Find Answers and Learn More</strong>
        <p className="parahelp">
          Below are helpful resources to guide you through using the MyPBC Portal. Click to view or download
          documentation, watch training videos, or access quick guides.
        </p>
      </div>
      <hr />
      <div className="subsection">
        <div className="helplist">
          <img className="iconImg" src={videoIcon} alt="Video" />
          <div className="list">
            <span className="helplisttitle">General PBC Training:</span><br />
            <span className="helplistsubtitle">
              Watch an introduction training video: <a href="javascript:void(0)" onClick={() => downloadDataFile('General_PBC_Training')}>General PBC Training</a>
            </span>
          </div>
        </div>
        <div className="helplist">
          <img className="iconImg" src={pdfIcon} alt="PDF" />
          <div className="list">
            <span className="helplisttitle">MyPBC Portal Overview:</span><br />
            <span className="helplistsubtitle">
              Download help documentation: <a href="javascript:void(0)" onClick={() => downloadDataFile('MyPBC_Portal_Overview')}>MyPBC Portal User Guide</a>
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div style={{ paddingLeft: '2%' }}>
        <strong className="help">Need more help?</strong>
        <p className="parahelp">
          Contact the <strong>MyPBC</strong> Portal team at <a href="mailto:odppassystem@deloitte.com">odppassystem@deloitte.com</a>.
        </p>
      </div>
    </section>
  );
};

export default Help;